import {
  awaitAnimate,
  Particle,
  ParticleModes,
} from "../../../engine/anims/Particle";
import Colors from "../../Colors";

export const TargetInvalidParticleBreed = {
  mode: ParticleModes.DRAW_OVER_LAST,
  char: null,
  fg: null,
  bg: Colors.DEEP_RED,
  animate: async (particle: Particle<void>) => {
    // eslint-disable-next-line no-constant-condition
    while (true) {
      await awaitAnimate({
        driver: particle.driver,
        from: Colors.DEEP_RED,
        to: Colors.RED,
        duration: 400,
        onUpdate: (latest) => {
          particle.bg = latest;
        },
      });

      await awaitAnimate({
        driver: particle.driver,
        from: Colors.RED,
        to: Colors.DEEP_RED,
        duration: 600,
        onUpdate: (latest) => {
          particle.bg = latest;
        },
      });
    }
  },
};
